export default __webpack_public_path__ + "static/media/coinbank.71e092a4.svg";